import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    topRow: _defineProperty({
      display: 'flex',
      justifyContent: 'space-between'
    }, mp, {
      display: 'none'
    }),
    flexContainer: {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: '1',
      minWidth: '0'
    },
    label: {
      padding: componentTheme.labelPadding,
      paddingLeft: componentTheme.labelLeftPadding,
      paddingBottom: componentTheme.labelBottomPadding,
      fontSize: componentTheme.labelFontSize,
      color: componentTheme.labelColor
    },
    editButtonWrapper: {
      alignSelf: 'flex-end',
      marginRight: componentTheme.editButtonWrapperRightMargin,
      paddingTop: componentTheme.labelPadding
    }
  };
};
export default generateStyle;